<template>
    <button
        @click.prevent="handleClick"
        type="button"
        tabindex="0"
        aria-label="Clear input"
        class="w-5 h-5 flex items-center justify-center active:outline-none active:ring-none focus:outline-none focus:outline-none hover:text-slate-800"
    >
        <Icon icon="x" svg-class="w-4 h-4" path-class="stroke-slate-500" />
    </button>
</template>

<script>
import Icon from '@/components/ui/icon/icon.vue';
export default {
    components: {
        Icon,
    },
    emits: ['clear'],
    setup(_, { emit }) {
        const handleClick = () => {
            emit('clear');
        };
        return { handleClick };
    },
};
</script>
